/* mm-chips: filtros do modal "Choose product" (Kaching) viram fotos redondas dos modelos (revert: remover este arquivo e a linha no snippets/meta-tags.liquid) */
(function(){
  if(window.__mmChips)return;window.__mmChips=1;
  var css='html .mm-chips{gap:12px !important;padding:4px 2px 12px !important;align-items:flex-start}'
  +'html .mm-chips button.mm-cp{display:flex;flex-direction:column;align-items:center;gap:6px;flex:0 0 auto;min-width:66px;padding:0;border:0;border-radius:0;background:none;color:#121212;font-size:12px;line-height:1.2;text-align:center}'
  +'html .mm-chips button.mm-cp.on{background:none;color:#121212;font-weight:700}'
  +'.mm-cp__i{position:relative;display:flex;align-items:center;justify-content:center;width:58px;height:58px;border-radius:50%;overflow:hidden;background:#f4f2ee;box-shadow:0 0 0 1px #d6d6d6;transition:box-shadow .15s}'
  +'.mm-cp__i img{display:block;width:100%;height:100%;object-fit:cover;transform:scale(1.12)}'
  +'.mm-cp__i--all{background:#121212;color:#fff;font-size:15px;font-weight:700;letter-spacing:.02em}'
  +'html .mm-chips button.mm-cp.on .mm-cp__i{box-shadow:0 0 0 3px #fff,0 0 0 5px #1b472b}'
  +'.mm-cp__n{display:block;white-space:nowrap}'
  +'.mm-cp__c{font-weight:400;opacity:.65}';
  var st=document.createElement('style');st.setAttribute('data-mm','chips');st.textContent=css;document.head.appendChild(st);
  function up(){
    var bars=document.querySelectorAll('.mm-chips:not([data-mmp])');
    for(var i=0;i<bars.length;i++){
      var bar=bars[i];var scope=bar.parentNode||document;
      bar.setAttribute('data-mmp','1');
      var btns=bar.querySelectorAll('button');
      for(var j=0;j<btns.length;j++){
        var b=btns[j];var txt=b.textContent.trim();var m=/^(.*?)\s*\((\d+)\)$/.exec(txt);var name=m?m[1]:txt;var cnt=m?m[2]:'';
        var img=null;
        if(name!=='All'){var card=scope.querySelector('[data-mm-model="'+name+'"]');var im=card&&card.querySelector('img');img=im?(im.currentSrc||im.src):null}
        b.setAttribute('aria-label',txt);b.classList.add('mm-cp');b.textContent='';
        var c=document.createElement('span');c.className='mm-cp__i'+(name==='All'?' mm-cp__i--all':'');
        if(name==='All'){c.textContent='All'}else if(img){var t=document.createElement('img');t.src=img;t.alt='';t.width=116;t.height=116;c.appendChild(t)}else{c.textContent=name.charAt(0)}
        var l=document.createElement('span');l.className='mm-cp__n';l.appendChild(document.createTextNode(name==='All'?'All':name));
        if(cnt){var k=document.createElement('span');k.className='mm-cp__c';k.textContent=' ('+cnt+')';l.appendChild(k)}
        b.appendChild(c);b.appendChild(l);
      }
    }
  }
  /* v26: agrupa as mutacoes por frame (antes rodava a cada mutacao do DOM = tarefas longas de 130-150 ms no PageSpeed) */
  var q=0;function soon(){if(q)return;q=1;requestAnimationFrame(function(){q=0;up()})}
  new MutationObserver(soon).observe(document.documentElement,{childList:true,subtree:true});
  up();
})();